import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, useFormikContext } from 'formik';

import QuestionField from './QuestionField';
import FormActions from '../../components/FormActions';
import { questionPropType } from '../questionTypes';

// noValidate meaning no native validation
// i.e. numbers want to set html attributes max, min, and step, but the native validation logic is not what we want
const noValidateQuestionTypes = ['decimal', 'integer'];

function QuestionFormBody({
  clearErrorMessage, errorMessage, fieldName, isMobile, question, onSkip, showProfileWarning, totalQuestions,
  setIsLoading,
}) {
  const { errors, isSubmitting, isValid, resetForm, setFieldError } = useFormikContext();
  useEffect(() => {
    if (errorMessage) {
      // This is predicated on the assumption (and current fact) that there is only one field in the ESQ forms
      // and that the server is not supplying a field name. (Is it? It's not being passed in.)
      setFieldError(fieldName, errorMessage);
      clearErrorMessage();
    }
  }, [clearErrorMessage, errorMessage, fieldName, setFieldError]);

  const handleSkip = async () => {
    await onSkip(resetForm);
  };

  // disable native validations if set in noValidateQuestionTypes
  const noValidateProp = noValidateQuestionTypes.includes(question.question_type) ? {
    noValidate: 'novalidate',
  } : {};

  useEffect(() => {
    // `setIsLoading(true)` so that we can disable the close button while the
    // screen is processing/loading
    setIsLoading(isSubmitting);
  }, [isSubmitting, setIsLoading]);


  // all input names are 'answer' except file uploads which are 'answerUpload'
  const effectiveMessage = errors.answer || errors.answerUpload;
  return (
    <Form className="question_form" {...noValidateProp}>
      <QuestionField
        key={question.question_id}
        errorMessage={effectiveMessage}
        isMobile={isMobile}
        question={question}
        showProfileWarning={showProfileWarning}
        totalQuestions={totalQuestions}
      />
      <FormActions
        // Add "!dirty ||" to the below to disable the Continue button until changed
        disableContinue={isSubmitting || !isValid}
        disableSkip={isSubmitting}
        onSkip={question.is_required ? null : handleSkip}
      />
    </Form>
  );
}

QuestionFormBody.propTypes = {
  clearErrorMessage: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  onSkip: PropTypes.func.isRequired,
  question: questionPropType.isRequired,
  setIsLoading: PropTypes.func,
  showProfileWarning: PropTypes.bool,
  totalQuestions: PropTypes.number.isRequired,
};

QuestionFormBody.defaultProps = {
  errorMessage: '',
  isMobile: false,
  setIsLoading: () => {},
  showProfileWarning: false,
};

export default QuestionFormBody;
